import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const elevenLabs = defineConnector({
  identifier: "elevenLabs",
  name: "ElevenLabs",
  tagLine: "AI voice synthesis platform",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.elevenlabs\\.io/.*",
  auth: (app) => headerAuth([{ name: "xi-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [ElevenLabs profile](https://elevenlabs.io/app/settings/api-keys) and copy your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          placeholder: "sk_...",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.elevenlabs.io/v1/user",
  },
});
